import camelize from 'camelize'

import { updateStateFromBackendAction } from '@/utils/eventsHelper'
import http from '@/utils/http'
import { routeFor } from '@/utils/router'

import assetReducers from './index'

const { actions } = assetReducers

export const fetchAssetDetails = ({ assetId, duration, role }) => dispatch => (
  http.get(routeFor('apiAsset', assetId), { duration, role })
  .then(response => {
    const camelizedResponse = camelize(response)

    dispatch(updateStateFromBackendAction(camelizedResponse))
    if(camelizedResponse.asset.selectedVariant) {
      dispatch({ type: 'gtm/onViewProduct' })
    }
  })
)

export const fetchTableOfContents = ({ path }) => dispatch => {
  dispatch(actions.fetchTableOfContentsStart())

  http.get(path).then(response => {
    dispatch(actions.fetchTableOfContentsSuccess(response))
  })
  .catch(error => {
    dispatch(actions.fetchTableOfContentsFailure(error))
  })
}

export const fetchOnlineResource = ({ path }) => dispatch => {
  dispatch(actions.fetchOnlineResourceStart())

  http.get(path).then(response => {
    dispatch(actions.fetchOnlineResourceSuccess(response.onlineResource))
  })
  .catch(response => {
    dispatch(actions.fetchOnlineResourceFailure(response))
  })
}

export const fetchRelatedAssets = ({ assetId, regionId }) => dispatch => {
  dispatch(actions.fetchRelatedAssetsStart())

  http.post(routeFor('apiRelatedAssets'), { assetId, regionId }).then(
    data => { dispatch(actions.fetchRelatedAssetsSuccess(data)) }
  ).catch(
    error => dispatch(actions.fetchRelatedAssetsFailure(error))
  )
}
